import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

import { useResponsive } from '@/composables/useResponsive'

export const useSidebarStore = defineStore('sidebar', () => {
  const isVisible = ref(false)
  const { isMobile } = useResponsive()

  const getIsVisible = computed(() => {
    return !isMobile.value || isVisible.value
  })

  function open () {
    isVisible.value = true
  }

  function close () {
    isVisible.value = false
  }

  return {
    isVisible,
    getIsVisible,
    open,
    close,
  }
})
